const json = (value: string): boolean => {
  try {
    JSON.parse(value)
  } catch (e) {
    return false
  }

  return true
}

const boolean = (value: any): boolean => {
  return ['true', 'false'].includes(String(value))
}

export default {
  json,
  boolean,
}
